export const formatTimeLeft = (seconds: number): string => {
  if (seconds >= 60) return `${ Math.floor(seconds / 60) }m remaining`;
  return `${ seconds }s remaining`;
};
